export default function DashboardLanding({ dashboards, onSelect }) {
    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-semibold text-gray-100">
                Dashboards
            </h1>

            <p className="text-sm text-gray-400">
                Select a dashboard to view role-specific insights.
            </p>

            <div className="grid grid-cols-3 gap-6">
                {dashboards.map(d => (
                    <div
                        key={d.id}
                        onClick={() => onSelect(d.id)}
                        className="
              p-6 rounded-xl
              bg-slate-900/70
              border border-slate-800
              cursor-pointer
              hover:border-accent-info/60
              hover:shadow-[0_0_24px_rgba(31,157,255,0.15)]
              transition
            "
                    >
                        <h2
                            className={`
                                text-lg font-semibold tracking-wide
                                ${d.enabled
                                    ? "text-accent-action"
                                    : "text-gray-100"
                                }
                            `}
                        >
                            {d.label}
                        </h2>

                        <p className="mt-2 text-sm text-gray-400">
                            {d.description}
                        </p>

                        {d.enabled && (
                            <div className="mt-1 text-[10px] font-mono uppercase tracking-widest text-accent-info">
                                Active
                            </div>
                        )}

                        {!d.enabled && (
                            <div className="mt-4 text-xs font-mono uppercase tracking-widest text-yellow-400">
                                Coming Soon
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}